export enum SendStatusEnum {
  SCHEDULED = 'scheduled',
  SENT = 'sent',
  CANCELED = 'canceled',
  ERROR = 'error',
  SEND_ERROR = 'send error',
}
